import React from 'react';
import './ProfileCreationLoader.css'; // 자신의 CSS 파일을 임포트

function ProfileCreationLoader() {
  return (
    <div className="loader-card">
      <div className="loader-spinner"></div>
      <h2>프로필 생성 중...</h2>
      <p>잠시만 기다려 주세요. AI가 당신의 프로필을 만들고 있습니다.</p>
      <p className="loader-note">* 이 과정은 몇 초 정도 소요될 수 있습니다.</p>
    </div>
  );
}

export default ProfileCreationLoader;